import axios from 'axios';

import constants from '../../../../constants';
import { EphiTeamMembers, SRABusinessAssociate, SRAElectronicMediaInventory } from './types';

const ontraqBaseAPIV2URL = `${constants.ONTRAQ_API_URL}/api2`;

export const getElectronicMediaInventory = (customerNumber: string, year: number) =>
  axios
    .get<SRAElectronicMediaInventory[]>(`${ontraqBaseAPIV2URL}/${customerNumber}/sra-electronic-media-inventory/year/${year}`)
    .then((res) => res.data);

export const updateElectronicMediaInventoryItem = (customerNumber: string, item: Partial<SRAElectronicMediaInventory>) =>
  axios.put(`${ontraqBaseAPIV2URL}/${customerNumber}/sra-electronic-media-inventory/${item.id}`, item).then((res) => res.data);

export const createElectronicMediaInventoryItem = (customerNumber: string, item: Partial<SRAElectronicMediaInventory>) =>
  axios
    .post<SRAElectronicMediaInventory>(`${ontraqBaseAPIV2URL}/${customerNumber}/sra-electronic-media-inventory`, item)
    .then((res) => res.data);

export const deleteElectronicMediaInventoryItem = (customerNumber: string, id: string) =>
  axios.delete(`${ontraqBaseAPIV2URL}/${customerNumber}/sra-electronic-media-inventory/${id}`).then((res) => res.data);

export const getSRABusinessAssociates = async (customerNumber: string, year: number) => {
  const { data } = await axios.get<SRABusinessAssociate[]>(`${ontraqBaseAPIV2URL}/${customerNumber}/sra-business-associates/${year}`);

  return data;
};

export const createSRABusinessAssociate = async ({ customer_number, ...businessAssociate }: Partial<SRABusinessAssociate>) => {
  const { data } = await axios.post<SRABusinessAssociate>(
    `${ontraqBaseAPIV2URL}/${customer_number}/sra-business-associates`,
    businessAssociate
  );

  return data;
};

export const updateSRABusinessAssociate = async ({ id, customer_number, ...businessAssociate }: SRABusinessAssociate) => {
  const payload = {
    name: businessAssociate.name,
    type: businessAssociate.type,
    address: businessAssociate.address,
  }

  const { data } = await axios.put<SRABusinessAssociate>(
    `${ontraqBaseAPIV2URL}/${customer_number}/sra-business-associates/${id}`,
    payload
  );

  return data;
};

export const deleteSRABusinessAssociate = async ({ id, customer_number }: SRABusinessAssociate) => {
  await axios.delete(`${ontraqBaseAPIV2URL}/${customer_number}/sra-business-associates/${id}`);

  return { id };
};

export const getEphiTeamMembers = (customerNumber: string, year: number) =>
  axios.get<EphiTeamMembers[]>(`${ontraqBaseAPIV2URL}/${customerNumber}/ephi-team-members?year=${year}`).then((res) => res.data);

export const deleteEphiTeamMember = (customerNumber: string, id: string) =>
  axios.delete(`${ontraqBaseAPIV2URL}/${customerNumber}/ephi-team-members/${id}`).then((res) => res.data);

export const updateEphiTeamMember = (customerNumber: string, member: Partial<EphiTeamMembers>) => {
  const payload = { ...member };
  delete payload.id;
  return axios.put<EphiTeamMembers>(`${ontraqBaseAPIV2URL}/${customerNumber}/ephi-team-members/${member.id}`, payload).then((res) => res.data);
}

export const createEphiTeamMember = (customerNumber: string, member: Partial<EphiTeamMembers>) =>
  axios.post<EphiTeamMembers>(`${ontraqBaseAPIV2URL}/${customerNumber}/ephi-team-members`, member).then((res) => res.data);
